'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    name: 'user-hollow',
    /* eslint-disable max-len */
    shape: _react2.default.createElement('path', { d: 'M512 638.359c151.63 0 442.252 88.448 442.252 221.124v82.132H69.75v-82.132c0-138.993 290.623-221.124 442.252-221.124zm0-63.177zm0 0c-170.581 0-505.429 94.77-505.429 284.305v145.309h1010.86V859.487c0-195.853-334.848-284.305-505.429-284.305zm0-492.793c120.042 0 221.124 101.087 221.124 221.124S632.037 524.637 512 524.637s-221.124-94.77-221.124-214.808c0-126.358 101.087-227.445 221.124-227.445zm0-63.18c-157.947 0-284.305 132.675-284.305 284.305 0 157.947 126.358 284.305 284.305 284.305s284.305-126.358 284.305-284.305c0-151.63-126.358-284.305-284.305-284.305z' }),
    /* eslint-enable max-len */
    viewbox: '0 0 1024 1024',
    label: 'User hollow'
};
//# sourceMappingURL=user-hollow.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/@spp/cn-skin-core/lib/cjs/svg/user-hollow.js
 ** module id = 293
 ** module chunks = 0
 **/